import React from "react";

import { SvgCompTeach } from "./teach";
import { SvgCompPractice } from "./practice";
import { SvgCompExam } from "./exam";
import { SvgCompAbroad } from "./abroad";
import { SvgCompUse } from "./use";
import styles from "./index.module.scss";
import { useDeviceType } from "../../../hooks/use-device-type";

export interface SvgCompProps {}

export function SvgComp(props: SvgCompProps) {
  const isMobile = useDeviceType() === "mobile";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={isMobile ? 400 : 600}
      height={isMobile ? 400 : 600}
      viewBox="-25 -25 600 600"
      className={styles.svgComp}
      style={{
        shapeRendering: "geometricPrecision",
        textRendering: "geometricPrecision",
        imageRendering: "optimizeQuality",
        fillRule: "evenodd",
        clipRule: "evenodd"
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      {...props}
    >
      <SvgCompTeach />
      <SvgCompPractice />
      <SvgCompExam />
      <SvgCompAbroad />
      <SvgCompUse />
    </svg>
  );
}
